import { SESSION_STORE_KEY, useSessionStore } from "@/store/sessionStore/sessionStore";

const CHANNEL_NAME = "auth-session-sync";
const SESSION_REQUEST_TYPE = "REQUEST_SESSION";
const SESSION_DATA_TYPE = "SESSION_DATA";
const TRANSFER_TIMEOUT_MS = 1500;
const TRANSFER_RETRY_INTERVAL_MS = 250;

let responderChannel: BroadcastChannel | null = null;

export function setupSessionSyncResponder(): void {
  if (responderChannel) return;

  responderChannel = new BroadcastChannel(CHANNEL_NAME);
  responderChannel.addEventListener("message", (event: MessageEvent) => {
    if (event.data?.type === SESSION_REQUEST_TYPE) {
      const data = sessionStorage.getItem(SESSION_STORE_KEY);
      if (data) {
        responderChannel?.postMessage({ type: SESSION_DATA_TYPE, payload: data });
      }
    }
  });
}

export function tryTransferSession(): Promise<void> {
  if (localStorage.getItem(SESSION_STORE_KEY) || sessionStorage.getItem(SESSION_STORE_KEY)) {
    return Promise.resolve();
  }

  return new Promise<void>((resolve) => {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    let settled = false;
    let retryTimer: ReturnType<typeof setInterval> | null = null;
    let timeoutTimer: ReturnType<typeof setTimeout> | null = null;

    const finish = () => {
      if (settled) return;
      settled = true;
      if (retryTimer) clearInterval(retryTimer);
      if (timeoutTimer) clearTimeout(timeoutTimer);
      channel.close();
      resolve();
    };

    channel.addEventListener("message", async (event: MessageEvent) => {
      if (event.data?.type === SESSION_DATA_TYPE && event.data?.payload) {
        sessionStorage.setItem(SESSION_STORE_KEY, event.data.payload);
        await Promise.resolve(useSessionStore.persist.rehydrate());
        finish();
      }
    });

    channel.postMessage({ type: SESSION_REQUEST_TYPE });
    retryTimer = setInterval(() => {
      if (settled) return;
      channel.postMessage({ type: SESSION_REQUEST_TYPE });
    }, TRANSFER_RETRY_INTERVAL_MS);
    timeoutTimer = setTimeout(finish, TRANSFER_TIMEOUT_MS);
  });
}
